// extracted by mini-css-extract-plugin
export default {"background-bag":"Button_background-bag__MglkA","shopping-cart":"Button_shopping-cart__i-zTh"};